import { baseApi } from '@shared/api'

export enum StatusType {
  FOR_MUST_BE_SIGNED = 'FOR_MUST_BE_SIGNED',
  CLOSED = 'CLOSED',
  BANK_EXECUTION = 'BANK_EXECUTION',
  DELETED = 'DELETED',
  EXPIRED = 'EXPIRED',
  BANK_REJECTED = 'BANK_REJECTED',
  BANK_SUCCESS = 'BANK_SUCCESS',
  BANK_ERROR = 'BANK_ERROR',
  PENDING_SIGNER = 'PENDING_SIGNER',
  SEND_TO_BANK = 'SEND_TO_BANK',
  PROCEED = 'PROCEED',
  CREATED = 'CREATED',
  EDITED = 'EDITED',
  CARD_READY = 'CARD_READY',
  CARD_RECEIVED = 'CARD_RECEIVED',
}

export enum MobilOperatorType {
  Azercell = 'Azercell',
  Bakcell = 'Bakcell',
  Azerfon = 'Azerfon',
  None = 'Yoxdur',
}

export interface OrderList {
  orderId: number
  orderNo: string
  transactionId: any
  customerName: string
  updatedDate: string
  cardSystem: string
  cardName: string
  cardCurrency: any
  orderType: string
  orderDeliveryType: string
  totalFee: any
  totalFeeCurrency: string
  currencyCommission: any
  status: string
}

export interface BusinessCardOrderShortList {
  orderList: OrderList[]
  totalCount: number
}

export interface BusinessCardListRequest {
  startDate: string
  endDate: string
  searchText?: string
  status: string
}

export interface SalaryCardStatusListRequest {
  searchText: string
  startDate: string
  endDate: string
}

export interface SalaryCardStatusList {
  status: StatusType
  count: number
}

export interface SalaryCardShortList {
  totalCount: number
  orderList: SalaryCardShortDetail[]
}

export interface SalaryCardShortDetail {
  createdDate: string
  orderNo: string
  cardType: 'VISA' | 'MASTERCARD'
  cardCurrency: string
  orderType: string
  orderDeliveryType: string
  totalCount: number
  rejectedCount: number
  status: string
  transactionId: string
}

export interface UpdateBusinessOrderStatus {
  transactionId: string
  fullName: string
  orderNo: string
}

// Order Detail
export interface BusinessCardDetail {
  orderNo: string
  transactionId: any
  customerNo: string
  customerName: string
  cardCurrency: any
  cardSystem: string
  cardName: string
  cardDuration: string
  cardId: string
  description: any
  status: string
  note: any
  cardAccount: string
  issueFree: string
  currencyIssueFree: string
  totalCommission: number
  currencyCommission: string
  orderType: string
  orderDeliveryType: string
  accountBranch: string
  accountBranchName: string
  transferredBranch: string
  transferredBranchName: string
  attachmanPdfId: any
  front?: FileDetail
  back?: FileDetail
  cardTariffId: number
  orderSalaryCardHistories: OrderSalaryCardHistory[]
  cardHolder: CardHolder
  trustedPerson: TrustedPerson
  commission: ComissionsType
}

export interface FileDetail {
  uid: string
  name: string
  status: 'done'
  url: string
  type: string
}

// export interface CardHolder {
//   cardHolderFullName: string
//   serialType: string
//   serialNo: string
//   pin: string
//   phoneNumber: string
//   mobileOperatorName: string
//   mobileOperatorCode: string
// }

export interface TrustedPerson {
  id: number
  fullName: any
  pin: any
  phone: any
  customerNo: any
  expiryDate: any
}

export interface OrderSalaryCardHistory {
  actionWithOrderStatus: string
  operatorUsername: string
  actionDate: string
  acquiredStatus: string
  previousStatus: any
  operatorFullName: string
}

export interface AccountResponse {
  accountNo: string
  currency: string
}

export enum CardCurrenyType {
  AZN = 'AZN',
  USD = 'USD',
  EUR = 'EUR',
}

export enum CardType {
  VISA = 'VISA',
  MASTERCARD = 'MASTERCARD',
}

export enum OrderType {
  ORDINARY = 'ORDINARY',
  URGENT = 'URGENT',
}

export enum OrderDeliveryType {
  BANK = 'BANK',
  COURIER = 'COURIER',
}

export type TrustedPersonType = {
  id?: number | null
  fullName: string
  pin: string
  phone: string
  expiryDate: string
}

export type UserInfomationType = {
  id?: number | null
  fullName: string
  pin: string
  phoneNumber: string
  serialType: string
  serialNo: string
  mobileOperator: string
}

export type ComissionsType = {
  issueFee: number
  preparationFee: number
  totalFee: number
}

export type OrderBusinessCardType = {
  isMain: boolean
  cardSystem: CardType
  cardName: string
  cardDuration: string
  cardId: string
  cardAccount: string
  transferredBranch: string
  accountBranch: string
  note?: string | null
  cardCurrency: CardCurrenyType
  orderType: OrderType
  frontFileId: string
  backFileId?: string | null
  orderDeliveryType: OrderDeliveryType
  trustedPerson: TrustedPersonType
  cardHolder: CardHolder
  commission: ComissionsType
  cardTariffId: number
}

export interface CardHolder {
  isMe: boolean
  cardHolderFullName: string
  serialType: string
  serialNo: number
  pin: string
  phoneNumber: string
  isDocExpired: boolean
  docExpiryDate: string
  mobileOperatorName: MobilOperatorType
}

// Posible Card Types

export interface PossibleBusinessCard {
  masterCardList: MasterCardList[]
  visaList: VisaList[]
  cardImages: Record<string, { small: string; original: string }>
  masterCardAvailable: boolean
  visaAvailable: boolean
  main: boolean
}

export interface MasterCardList {
  cardId: number
  issueFee: number
  cardName: string
  paymentSystem: string
  cardDuration: CardDuration[]
}

export interface VisaList {
  cardId: number
  issueFee: number
  cardName: string
  paymentSystem: string
  cardDuration: CardDuration[]
}

export interface CardDuration {
  year: number
  amount: number
  cardTariffId: number
}

export const businessCardOrderApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    businessCardList: builder.query<
      BusinessCardOrderShortList,
      BusinessCardListRequest
    >({
      query: (data) => {
        return {
          url: '/ib/order/card/business/short-list',
          method: 'POST',
          data,
        }
      },
      serializeQueryArgs: ({ queryArgs }) => 'fetchBusinessCardList',
      providesTags: (result) => {
        return result
          ? [
              ...result.orderList.map(({ orderNo }) => ({
                type: 'BusinessCardList' as const,
                id: orderNo,
              })),
              { type: 'BusinessCardList', id: 'List' },
            ]
          : [{ type: 'BusinessCardList', id: 'List' }]
      },
    }),
    fetchCreateBusinessCard: builder.mutation<any, any>({
      query: (data) => ({
        url: '/ib/order/card/business/create',
        method: 'POST',
        data,
        skipGlobalError: true,
      }),
    }),
    updateBusinessCardOrder: builder.mutation<any, any>({
      query: (data) => ({
        url: '/ib/order/card/business/update',
        method: 'POST',
        data,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled
          dispatch(
            businessCardOrderApi.util.invalidateTags(['BusinessCardStatusList'])
          )
        } catch (error) {}
      },
    }),
    deleteBusinessCardOrder: builder.mutation<any, any>({
      query: (data) => ({
        url: '/ib/order/card/business/delete',
        method: 'POST',
        data,
        skipGlobalError: true,
      }),
      invalidatesTags: ['BusinessCardStatusList', 'BusinessCardList'],
    }),
    businessCardStatusList: builder.query<
      SalaryCardStatusList[],
      SalaryCardStatusListRequest
    >({
      query: (data) => ({
        url: '/ib/order/card/business/statuses',
        method: 'POST',
        data,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled

          if (data.length === 0) {
            dispatch(
              businessCardOrderApi.util.updateQueryData(
                'businessCardList',
                'fetchBusinessCardList',
                (draftPosts) => {
                  draftPosts.orderList.splice(0, draftPosts.orderList.length)
                }
              )
            )
          }
        } catch (error) {}
      },
      providesTags: ['BusinessCardStatusList'],
    }),
    updateBusinessCardOrderStatus: builder.mutation<
      any,
      UpdateBusinessOrderStatus
    >({
      query: (data) => ({
        url: '/ib/order/card/business/update/status',
        method: 'POST',
        data,
        skipGlobalError: true,
      }),
    }),
    businessCardOrderDetail: builder.mutation<
      BusinessCardDetail,
      { orderNo: string }
    >({
      query: ({ orderNo }) => ({
        url: '/ib/order/card/business/details',
        data: { orderNo },
        method: 'POST',
        skipGlobalError: true,
      }),
    }),
    businessCardQhtStatus: builder.query<
      boolean,
      { status: 'qht' | 'frozen'; page: string }
    >({
      query: (arg) => ({
        url: `/ib/order/card/business/${arg.status}/status`,
        method: 'POST',
        skipGlobalError: true,
      }),
      structuralSharing: true,
      providesTags: (result, error, arg) => [
        { type: 'BusinessCardQhtStatus', id: arg.status },
      ],
      serializeQueryArgs: ({ queryArgs }) =>
        `${queryArgs.status}-${queryArgs.page}`,
      keepUnusedDataFor: 0,
    }),
    customerAccountList: builder.mutation<
      { accounts?: AccountResponse[]; status: string; message: string },
      { currency: string }
    >({
      query: (data) => ({
        url: `/ib/order/card/business/accounts`,
        method: 'POST',
        data,
      }),
    }),
    cardHolderByPin: builder.mutation<CardHolder, void>({
      query: () => ({
        url: '/ib/order/card/business/customer/by-fin',
        method: 'POST',
        skipGlobalError: true,
      }),
    }),
    possibleBusinessCard: builder.mutation<
      PossibleBusinessCard,
      { iban: string }
    >({
      query: (data) => ({
        url: '/ib/order/card/business/possible-card',
        method: 'POST',
        data,
        skipGlobalError: false,
      }),
    }),
  }),
})

export const {
  useBusinessCardListQuery,
  useLazyBusinessCardListQuery,
  useBusinessCardStatusListQuery,
  useLazyBusinessCardStatusListQuery,
  useDeleteBusinessCardOrderMutation,
  useBusinessCardOrderDetailMutation,
  useUpdateBusinessCardOrderStatusMutation,
  useBusinessCardQhtStatusQuery,
  useLazyBusinessCardQhtStatusQuery,
  useCustomerAccountListMutation,
  useCardHolderByPinMutation,
  useFetchCreateBusinessCardMutation,
  usePossibleBusinessCardMutation,
  useUpdateBusinessCardOrderMutation,
} = businessCardOrderApi
